export type GiftCardStatus = 'not_used' | 'used' | 'pending';

export const NOT_USED = 'not_used';
export const USED = 'used';
export const PENDING = 'pending';
